module.exports = __webpack_public_path__ + "media/partner_mo.4c09cbf8.mp4";